export enum GroupBy {
	TYPES = 'Types',
	SUBTYPES = "Subtypes",
	STYLESFUNCTIONS = 'StylesFunctions'
}


// WEBPACK FOOTER //
// ./src/ts/Apps/Common/Interfaces/GroupBy.ts